module.exports = __webpack_public_path__ + "static/media/home-image-2.f88db747.jpg";